import React from 'react'
import { TrackerProps } from '../../types'
import { ActiveCasesTable } from './ActiveCasesTable'
import {
    StyledGridItem,
    StyledGridTitleItem,
    StyledJabTrackerContainer,
    StyledTitle,
} from './JabTracker.styled'
import { WAVaccinationBar } from './WAVaccinationBar'

const theWestImageSM = require('./assets/thewest_covidtracker-sm.png')
const theWestImageLG = require('./assets/thewest_covidtracker-lg.png')

export function TWJabTracker({
    containerRatios,
    isLoading,
    isError,
    data,
    type,
}: TrackerProps) {
    return (
        <StyledJabTrackerContainer
            containerRatios={containerRatios}
            isLoading={isLoading || isError}
            type={type}
        >
            <StyledGridTitleItem type={type}>
                <StyledTitle>COVID-19 Tracker</StyledTitle>
                <img
                    className="jabtracker-image"
                    src={type === 'large' ? theWestImageLG : theWestImageSM}
                    alt="covid tracker decorative image"
                />
            </StyledGridTitleItem>

            <StyledGridItem type={type}>
                {data && <ActiveCasesTable data={data} type={type} />}
            </StyledGridItem>

            <StyledGridItem>
                {data && (
                    <WAVaccinationBar
                        data={data}
                        isLoading={isLoading}
                        type={type}
                    />
                )}
            </StyledGridItem>
        </StyledJabTrackerContainer>
    )
}
